module.exports = __webpack_public_path__ + "media/honey-icons/icon-window-71ff4c53.svg";